import React, { useState } from 'react';
import './WhatsAppFloat.css';

function WhatsAppFloat() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });

  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const numbers = value.replace(/\D/g, '');

    // Limit to 11 digits (Brazilian mobile: XX XXXXX-XXXX)
    const limited = numbers.substring(0, 11);

    if (limited.length >= 3) {
      if (limited.length >= 7) {
        // Format as (XX) XXXXX-XXXX
        return `(${limited.substring(0, 2)}) ${limited.substring(2, 7)}-${limited.substring(7)}`;
      } else {
        // Format as (XX) XXXXX
        return `(${limited.substring(0, 2)}) ${limited.substring(2)}`;
      }
    } else if (limited.length >= 1) {
      // Format as (XX
      return `(${limited}`;
    }

    return limited;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Basic input sanitization
    const sanitizeInput = (input) => {
      return input
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // Remove script tags
        .replace(/javascript:/gi, '') // Remove javascript: protocol
        .replace(/on\w+\s*=/gi, '') // Remove event handlers like onclick=
        .trim();
    };

    if (name === 'phone') {
      // Apply phone formatting
      const formattedPhone = formatPhoneNumber(value);
      setFormData({
        ...formData,
        [name]: formattedPhone,
      });
    } else {
      // Sanitize other inputs
      const sanitizedValue = sanitizeInput(value);
      setFormData({
        ...formData,
        [name]: sanitizedValue,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Construir mensagem do WhatsApp
    const whatsappMessage =
      `Olá! Gostaria de solicitar um orçamento:

` +
      `Nome: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Telefone: ${formData.phone}\n` +
      `Serviço: ${formData.service || 'Não especificado'}\n` +
      `Detalhes: ${formData.message}`;

    // Codificar a mensagem para URL
    const encodedMessage = encodeURIComponent(whatsappMessage);

    // Número do WhatsApp
    const phoneNumber =
      '55' + (process.env.REACT_APP_WHATSAPP_NUMBER?.replace(/[^0-9]/g, '') || '66999230430');

    // Redirecionar para WhatsApp
    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');

    // Limpar formulário e fechar modal
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: '',
    });
    setIsModalOpen(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // Clear all form fields when closing
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: '',
    });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      {/* Floating WhatsApp Button */}
      <div
        className="whatsapp-float"
        onClick={openModal}
        onKeyDown={(e) => e.key === 'Enter' && openModal()}
        role="button"
        tabIndex={0}
        aria-label="Abrir formulário WhatsApp"
      >
        <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
        </svg>
        <span className="whatsapp-tooltip">Solicitar Orçamento</span>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="whatsapp-modal-overlay"
          onClick={closeModal}
          onKeyDown={(e) => e.key === 'Escape' && closeModal()}
          role="button"
          aria-label="Close modal"
          tabIndex={0}
        >
          <div className="whatsapp-modal" onClick={(e) => e.stopPropagation()} role="presentation">
            <div className="whatsapp-modal-header">
              <h3>Solicitar Orçamento via WhatsApp</h3>
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit} className="whatsapp-form">
              <div className="form-group">
                <label htmlFor="wa-name">Nome Completo *</label>
                <input
                  type="text"
                  id="wa-name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  maxLength="100"
                  pattern="[A-Za-zÀ-ÿ\s]+"
                  title="Apenas letras e espaços são permitidos"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="wa-email">Email *</label>
                <input
                  type="email"
                  id="wa-email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  maxLength="254"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  title="Digite um email válido"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="wa-phone">Número de Telefone *</label>
                <input
                  type="tel"
                  id="wa-phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(66) 99999-9999"
                  maxLength="15"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="wa-service">Serviço Necessário</label>
                <select
                  id="wa-service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                >
                  <option value="">Selecione um serviço</option>
                  <option value="munck-convencional">Munck Convencional (45 ton.metro)</option>
                  <option value="munck-especial-e8">Munck Especial E8 (46 ton.metro)</option>
                  <option value="munck-especial-flyjib">
                    Munck Especial FLYJIB (62 ton.metro)
                  </option>
                  <option value="guindaste-70-toneladas">Guindaste 70 Toneladas (59m lança)</option>
                  <option value="guindaste-90-toneladas-zoomlion">
                    Guindaste 90 Toneladas Zoomlion (65m lança)
                  </option>
                  <option value="guindaste-90-toneladas-sany">
                    Guindaste 90 Toneladas SANY (76,5m lança)
                  </option>
                  <option value="other">Outro / Não tenho certeza</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="wa-message">Detalhes do Projeto *</label>
                <textarea
                  id="wa-message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Por favor, descreva seu projeto, localização, cronograma e quaisquer requisitos específicos..."
                  maxLength="1000"
                  required
                ></textarea>
              </div>

              <button type="submit" className="whatsapp-submit-button">
                Enviar via WhatsApp
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="currentColor"
                  style={{ marginLeft: '8px' }}
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default WhatsAppFloat;
